import { ICriteria } from '../contracts/criteria.contract';

const criteriaDescription: { [key in keyof ICriteria]?: string } = {
    FishingVessel: 'Fishing Vessel',
    SelfPropelled: 'Self-Propelled Mobile Offshore Drilling Unit',
    RoRoVehicleCarrier: 'RoRo Vehicle Carrier',
    RoRoCargoShip: 'RoRo Cargo Ship',
    RoRoPassengerShip: 'RoRo Passenger Ship',
    HighSpeedCraft: 'High-Speed Craft',
    MobileOffshoreDrillingUnit: 'Mobile Offshore Drilling Unit',
    PassengerShip: 'Passenger Ship',
    DynamicallySupportedCraft: 'Dynamically Supported Craft',
    ContainerCarrier: 'Container Carrier',
    GeneralCargoCarrier: 'General Cargo Carrier',
    RefrigeratedCargoCarrier: 'Refrigerated Cargo Carrier',
    ChemicalCarrier: 'Chemical Carrier',
    GasLNGCarrier: 'Gas/LNG Carrier',
    LNGCarrier: 'LNG Carrier',
    CrudeTanker: 'Crude Tanker',
    ProductTanker: 'Product Tanker',
    BulkCarrier: 'Bulk Carrier',
    CombinationCarrier: 'Combination Carrier',
    OreCarrier: 'Ore Carrier',
    OffshoreSupportVessel: 'Offshore Support Vessel',
    EntryIntoForceAfterDate: 'Entry into Force After Date',
    EntryIntoForceBeforeDate: 'Entry into Force Before Date',
    Mandatory: 'Mandatory',
    Guideline: 'Guideline',
    Hardware: 'Hardware',
    Operational: 'Operational',
    Retroactive: 'Retroactive',
    New: 'New',
    GrossTonnage: 'Gross Tonnage',
    NumberOfPassengers: 'Number of Passengers',
    Deadweight: 'Deadweight (DWT)',
    LoadLineLength: 'Load Line Length (LLL)',
    LengthOverall: 'Length Overall (LOA)',
    ContractAfterDate: 'Contract After Date',
    ContractBeforeDate: 'Contract Before Date',
    KeelLayAfterDate: 'Keel Lay After Date',
    KeelLayBeforeDate: 'Keel Lay Before Date',
    DeliveryAfterDate: 'Delivery After Date',
    DeliveryBeforeDate: 'Delivery Before Date',
    MARPOL: 'MARPOL',
    SOLAS: 'SOLAS',
    STCW: 'STCW',
    AFS: 'AFS',
    ICLL: 'ICLL',
    BWM: 'BWM',
    ExpiryAfterDate: 'Expiry After Date',
    ExpiryBeforeDate: 'Expiry Before Date',
    UserSearchQuery: 'Text Search'
};

// Translates selected criteria properties into human-readable descriptions
const getDescriptionByCriteria = (criteria: ICriteria): string[] => {
    return Object.keys(criteria)
        .filter((key) => criteria[key as keyof ICriteria])
        .map((key) => criteriaDescription[key as keyof ICriteria]!)
        .filter((description) => description !== undefined); // Filter out any undefined descriptions, if any
};

const getCriteriaPropertyByDescription = (description: string): keyof ICriteria | undefined => {
    return (Object.keys(criteriaDescription) as (keyof ICriteria)[]).find((key) => criteriaDescription[key] === description);
};

const CriteriaText = {
    criteriaDescription,
    getDescriptionByCriteria,
    getCriteriaPropertyByDescription
};

export default CriteriaText;
